import { compareGreater } from '@dte/otw-utils-core/src/objects/compare/compareGreater';
import { filterRecord } from '@dte/otw-utils-core/src/objects/filterRecord';
import type { MessageDetail } from '../../interfaces/api/messageDetail/MessageDetail';

export function getMessageDetailsByPriority<T extends MessageDetail>(map: Record<string, T>): T[] {
	// Filter to those that have priority
	let filtered = filterRecord(map, (value) => value?.priority !== undefined);

	// Filter out any that are currently disabled
	filtered = filterRecord(filtered, (value) => !value.disabled);

	let values = Object.values(filtered);

	// Sort highest priority first
	values = values.sort((a, b) => compareGreater(a.priority, b.priority));

	// TODO: this needs to return the keys, not the values

	return values;
}
